<template>
  <div class="user-list-container">
    <el-tabs
      v-model="activeTab"
      type="border-card"
    >
      <el-tab-pane
        lazy
        name="sellers"
      >
        <span
          v-if="locale === 'en'"
          slot="label"
        >{{ $t('account-settings.messages.tab.sellers') }} ({{ sellersCount }})</span>
        <span
          v-else
          slot="label"
        >({{ sellersCount }}) {{ $t('account-settings.messages.tab.sellers') }}</span>
        <entity-list
          ref="sellersList"
          res="messages"
          :no-items-text="$t('entity-list.no-messages')"
          :filter="sellerFilters"
          :sort="sellerSort || []"
          :res-options="resourceOptions"
        >
          <template
            slot="item"
            slot-scope="{ item }"
          >
            <item
              :data="item"
              :is-mobile="isMobile"
              :is-selected="Number(item.user_id) === Number($route.params.userId) && Number(item.ad_id) === Number($route.params.adId)"
              @selected="onSelected"
            />
          </template>
        </entity-list>
      </el-tab-pane>
      <el-tab-pane
        lazy
        name="buyers"
      >
        <span
          v-if="locale === 'en'"
          slot="label"
        >{{ $t('account-settings.messages.tab.buyers') }} ({{ buyersCount }})</span>
        <span
          v-else
          slot="label"
        >({{ buyersCount }}) {{ $t('account-settings.messages.tab.buyers') }}</span>
        <entity-list
          ref="buyersList"
          res="messages"
          :no-items-text="$t('entity-list.no-messages')"
          :filter="buyersFilters"
          :sort="buyersSort || []"
          :res-options="resourceOptions"
        >
          <template
            slot="item"
            slot-scope="{ item }"
          >
            <item
              :data="item"
              :is-mobile="isMobile"
              :is-selected="Number(item.user_id) === Number($route.params.userId) && Number(item.ad_id) === Number($route.params.adId)"
              @selected="onSelected"
            />
          </template>
        </entity-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import EntityList from '../Core/EntityList';
  import Item from './MessageUserList/Item';

  export default {
    name: 'MessageUserList',
    components: {
      EntityList,
      Item,
    },
    props: {
      reloadUsersList: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        sellersCount: 0,
        buyersCount: 0,
        sellerSort: [{
          property: 'created_at',
          direction: 'desc'
        }],
        buyersSort: [{
          property: 'created_at',
          direction: 'desc'
        }],
        baseFilters: [{
          property: 'groupedLatestMessages',
          operator: 'scope',
          value: null,
        }, {
          property: 'ad.active',
          operator: '=',
          value: true,
        }],
        resourceOptions: {
          'user:file': true,
          'ad:file': true,
          'ad:user:file': true,
          unread_count: true,
        },
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        user: state => state.auth.user,
        locale: state => state.locale,
      }),
      sellerFilters() {
        return this.baseFilters
          .concat([{
            property: 'user_id',
            operator: '=',
            value: this.user.id,
          }]);
      },
      buyersFilters() {
        return this.baseFilters
          .concat([{
            property: 'ad.user_id',
            operator: '=',
            value: this.user.id,
          }]);
      },
      activeTab: {
        get() {
          return this.$route.params.tab || 'sellers';
        },
        set(val) {
          this.$router.push({
            name: this.$route.name,
            params: {
              tab: val,
            },
          });
        },
      },
    },
    watch: {
      reloadUsersList(newVal) {
        if (newVal) {
          const lists = ['sellersList', 'buyersList'];

          lists.forEach((listName) => {
            if (this.$refs[listName]) {
              this.$refs[listName].doRefresh();
            }
          });
        }
      },
    },
    async created() {
      const { data: { sellers, buyers } } = await this.$http.get('messages/contact-counts') || {};
      this.sellersCount = sellers;
      this.buyersCount = buyers;
    },
    methods: {
      onSelected(item) {
        this.$router.push({
          name: this.$route.name,
          params: {
            tab: this.activeTab,
            userId: item.user_id,
            adId: item.ad_id,
          } });
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AccountSettings/MessageUserList.vue